import React from 'react';
import dotAccess from 'dot-access';
import { filterValue } from './filterValue';
import './OutputText.css';
import { booleanFormatter, localeFormatter } from '../../functions/textFormatter';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';

export const OutputBoolean = props => (
  <OutputText formatter={booleanFormatter} {...props} />
);

export const LocalizedOutputText = (props, context) => (
  <OutputText formatter={localeFormatter(context.locale)(props.prefix)} {...props} />
);

LocalizedOutputText.contextTypes = {
  locale: PropTypes.string,
};

const simpleOutputFormat = ({ value, formatter }) => (
  (value && formatter) ? formatter(value) : value
);


export const SimpleOutputText = (props, context) => {

// XXX FME: Probabilmente si può fare in altro modo
//	if(props.resource != undefined){
//		  if((!props.resource.isSubstanceCancerous || props.resource.isSubstanceCancerous == null || props.resource.isSubstanceCancerous == undefined) &&
//				     (!props.resource.isSubstanceMutagen || props.resource.isSubstanceMutagen == null || props.resource.isSubstanceMutagen == undefined) &&
//						     props.label === "substancesManagement.handlingTemperature.name"){
//							  
//							  return (null);
//				  }
//	}


				  
				  return (
						  <div className="OutputText" style={props.style}>
						    <div className="output-label">{getLabel(context.locale, props.label)}</div>
						    <span>{simpleOutputFormat(props)}</span>
						  </div>
				  );	
		

};

SimpleOutputText.contextTypes = {
  locale: PropTypes.string,
};

export const LocalizedSimpleOutputText = (props, context) => (
  <SimpleOutputText formatter={localeFormatter(context.locale)(props.prefix)} {...props} />
);

LocalizedSimpleOutputText.contextTypes = {
  locale: PropTypes.string,
};

const OutputText = props => (
  <SimpleOutputText
      label={props.label}
      value={filterValue(props)}
      style={props.style}
      resource={props.name ? dotAccess.get(props.resource, props.name) : props.resource}
  />
);


export default OutputText;



// WEBPACK FOOTER //
// ./src/main/components/output/OutputText.js